var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"background":"#292867 !important"},attrs:{"fluid":"","grid-list-md":""}})}
var staticRenderFns = []

export { render, staticRenderFns }